import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function ReturnBanner() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnTo = searchParams.get("returnTo");

  if (!returnTo) return null;

  return (
    <div style={{
      backgroundColor: "var(--neon-pink, #ff2a6d)",
      color: "white",
      padding: "10px",
      textAlign: "center",
      fontWeight: "bold",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
    }}>
      You are currently completing an onboarding task.{" "}
      <Link to={returnTo} style={{ color: "white", textDecoration: "underline", marginLeft: "10px" }}>
        Return to Onboarding
      </Link>
    </div>
  );
}
